<template>
    <Modal :is-open="isOpen" @close="$emit('close')">
        <template #title>{{ $t('legal.privacy.title') }}</template>

        <div class="prose prose-lg max-w-none">
            <p class="text-gray-600 mb-6">{{ $t('legal.privacy.lastUpdated') }}</p>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.introduction.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.privacy.introduction.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.informationCollected.title') }}</h2>
                <p class="text-gray-700 mb-3">{{ $t('legal.privacy.informationCollected.content') }}</p>
                <ul class="list-disc pl-6 space-y-2">
                    <li v-for="(item, index) in $tm('legal.privacy.informationCollected.items')" :key="index" class="text-gray-700">
                        {{ item }}
                    </li>
                </ul>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.howWeUse.title') }}</h2>
                <p class="text-gray-700 mb-3">{{ $t('legal.privacy.howWeUse.content') }}</p>
                <ul class="list-disc pl-6 space-y-2">
                    <li v-for="(item, index) in $tm('legal.privacy.howWeUse.items')" :key="index" class="text-gray-700">
                        {{ item }}
                    </li>
                </ul>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.dataSharing.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.privacy.dataSharing.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.dataSecurity.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.privacy.dataSecurity.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.yourRights.title') }}</h2>
                <p class="text-gray-700 mb-3">{{ $t('legal.privacy.yourRights.content') }}</p>
                <ul class="list-disc pl-6 space-y-2">
                    <li v-for="(item, index) in $tm('legal.privacy.yourRights.items')" :key="index" class="text-gray-700">
                        {{ item }}
                    </li>
                </ul>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.cookies.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.privacy.cookies.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.changes.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.privacy.changes.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.privacy.contact.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.privacy.contact.content') }}</p>
            </section>
        </div>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '../molecules/Modal.vue';

export default defineComponent({
    name: 'PrivacyPolicyModal',
    components: {
        Modal
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close']
});
</script>
